import { render, staticRenderFns } from "./soft3d.vue?vue&type=template&id=5ad47b99&scoped=true"
import script from "./soft3d.vue?vue&type=script&lang=js"
export * from "./soft3d.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad47b99",
  null
  
)

export default component.exports